<template>
  <div>
    <gmap-map
      :center="center"
      :zoom="zoom"
      style="width:100%;  height: 400px;"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="center=m.position"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: 'GoogleMap',
  data () {
    return {
      // default to Montreal to keep it simple
      // change this to whatever makes sense
      zoom: 2,
      center: { lat: 25.669875, lng: -100.3742662 },
      markers: [
        {
          position: {
            lat: 25.669875,
            lng: -100.3742662
          }
        },
        {
          position: {
            lat: 19.3905342,
            lng: -99.1653427
          }
        },
        {
          position: {
            lat: 20.5460082,
            lng: -100.431076
          }
        },
        {
          position: {
            lat: 9.9264281,
            lng: -84.0286431
          }
        }
      ],
      places: [],
      currentPlace: null
    }
  },
  computed: {
    windowSize () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 0
        case 'sm': return 1
        case 'md': return 2
        case 'lg': return 3
        case 'xl': return 4
        default: return 0
      }
    }
  },
  mounted () {
    this.centerMap()
  },
  methods: {
    centerMap () {
      if (this.windowSize < 2) {
        this.zoom = 14
      } else {
        this.zoom = 14
      }
    }
  }
}
</script>
